import * as Yup from 'yup';
const validationSchema = Yup.object().shape({
	amount: Yup.string().required().label('Amount'),
	user: Yup.string().required().label('User'),

});
const Inputs = [
	{
		name: 'amount',
		label: 'Amount',
		type: 'text',
		value: 'single',
		valueAttr: 'amount',
	},
	{
		name: "user",
		label: 'User',
		value: "single",
		type: "select",
		valueAttr: "userId",
		required: true,
	},
	
	

];

export { Inputs, validationSchema };
